
import React, { useEffect, useState } from "react"
import { md, pki } from "node-forge"
import classNames from "classnames"

const KeyInfo = ({privateKey, privateKeyPem}) => {
  const [downloadUrl, setDownloadUrl] = useState(null)
  const [fingerprint, setFingerprint] = useState(null)

  useEffect(() => {
      if (!privateKeyPem) {
          return
      }
      const blob = new Blob([privateKeyPem], {type: 'application/x-pem-file'})
      const url = URL.createObjectURL(blob)
      setDownloadUrl(url)
    }, [privateKeyPem])

  useEffect(() => {
      if (!privateKey) {
          return
      }
      const publicKey = pki.rsa.setPublicKey(privateKey.n, privateKey.e);
      const fingerprint = pki.getPublicKeyFingerprint(publicKey, {
        md: md.sha256.create(),
        encoding: 'hex',
        delimiter: ':'
      })
      setFingerprint(fingerprint)
    }, [privateKey])

  return (<div>
    { fingerprint &&  
         <p>Fingerprint: <code>{fingerprint}</code></p>
    }
    { downloadUrl && <>
         <p className="alert alert-info">Please keep the private safe and
         secure.</p>
         <a href={downloadUrl} download="key.pem" className="btn btn-primary">
            Download private key
         </a>
    </>}
    { (!fingerprint && !downloadUrl) &&
        <p>No private key available</p>
    }
  </div>)
}

export default KeyInfo
